<script>

    import { fade } from 'svelte/transition'
    import { toast } from 'bulma-toast'
    import { shipmentStore, shipmentsStore } from '../stores'

    import TrackingsService from '../$services/trackings.service'
    import DateMethods from '../$methods/date.methods.js'
    
    import Spinner from '../$components/spinner.svelte'
    import Message from '../$components/message.svelte'

    let loading = false
    let trackings = []

    getTracking()

    async function getTracking() {

        loading = true
        const resp = await TrackingsService.getTracking($shipmentStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        trackings = resp.data

        if(resp.trackingStatus)
            $shipmentStore.trackingStatus = resp.trackingStatus

        $shipmentsStore.tracking = resp.data

        shipmentsStore.replace($shipmentStore)
    }

</script>

<style>
    .item {
        border-bottom: solid 1px whitesmoke;
        margin-bottom: 8px;
        padding: 8px;
    }
</style>

<div class="title is-4">Tracking</div>

<Message show={!loading && !trackings.length} />
<Spinner {loading} />

{#if !loading && trackings.length}
    {#each trackings as tracking, index}
        <div class="item">
            <small>{ DateMethods.dateTimeLarge(tracking.created) }</small>
            <div class="title is-5">{ tracking.name }</div>
            <div class="subtitle is-6">{ tracking.details }</div>
        </div>
    {/each}
{/if}